// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"3c3c2221","312":"faaa4a06","551":"2ed5c09f","629":"9431009b","638":"07cdfd28","712":"45869ec9","800":"3e66c215"}[chunkId] + ".chunk.js";
};